/* eslint-disable max-statements */
/* eslint-disable complexity */
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';
import i18next from 'i18next';

import constants from '../../../constants';
import redux, { RootState } from '../../index';

type RequestExportResponse = {
  fileName: string;
};

const pauseUnpauseMachineRequest = createAsyncThunk(
  'api/bulk-pause-unpause-machine',
  async (_data, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const authenticity_token = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute('content');

    if (!state.bulkPauseUnpause.customerId || !authenticity_token) {
      const errorMessage = i18next.t('modal.api.error', {
        ns: 'bulkPauseUnpause',
      });
      thunkAPI.dispatch(redux.banner.setSeverity('alert'));
      thunkAPI.dispatch(redux.banner.setContent(errorMessage));
      thunkAPI.dispatch(redux.banner.show());

      thunkAPI.rejectWithValue(errorMessage);
      return;
    }

    let response: AxiosResponse<RequestExportResponse, string>;

    let url;
    let payload = {};

    if (state.bulkPauseUnpause.action === 'unpause') {
      url = constants.endpoints.unpauseMachine;
      payload = {
        authenticity_token,
        managed_machine_ids: state.bulkPauseUnpause.ids,
      };
    } else if (state.bulkPauseUnpause.pauseOption === 'manuallyPaused') {
      url = constants.endpoints.pauseMachine;
      payload = {
        authenticity_token,
        managed_machine_ids: state.bulkPauseUnpause.ids,
        reason: state.bulkPauseUnpause.reason,
      };
    } else {
      url = constants.endpoints.pauseMachine;
      payload = {
        authenticity_token,
        managed_machine_ids: state.bulkPauseUnpause.ids,
        pause_for_days: state.bulkPauseUnpause.days,
        pause_for_hours: state.bulkPauseUnpause.hours,
        reason: state.bulkPauseUnpause.reason,
      };
    }

    try {
      if (state.bulkPauseUnpause.customerGroupId) {
        payload = {
          ...payload,
          customer_group_id: state.bulkPauseUnpause.customerGroupId,
        };
      } else {
        payload = {
          ...payload,
          customer_id: state.bulkPauseUnpause.customerId,
        };
      }
      response = await axios.post(url, payload, {
        validateStatus: (status) => status < 300,
        withCredentials: true,
      });
    } catch (e: unknown) {
      const errorMessage = i18next.t('modal.api.error', {
        ns: 'bulkPauseUnpause',
      });
      thunkAPI.dispatch(redux.banner.setSeverity('alert'));
      thunkAPI.dispatch(redux.banner.setContent(errorMessage));
      thunkAPI.dispatch(redux.banner.show());

      thunkAPI.rejectWithValue(e);
      return;
    }

    thunkAPI.dispatch(redux.banner.setSeverity('success'));
    thunkAPI.dispatch(
      redux.banner.setContent(
        i18next.t(
          state.bulkPauseUnpause.action === 'unpause'
            ? 'modal.api.successUnpaused'
            : 'modal.api.successPaused',
          {
            count: state.bulkPauseUnpause.names.length,
            ns: 'bulkPauseUnpause',
          },
        ),
      ),
    );
    thunkAPI.dispatch(redux.banner.show());
    window.dispatchEvent(new Event('bulkApiSuccess'));
    return response.data;
  },
);

export default pauseUnpauseMachineRequest;
